import { render, staticRenderFns } from "./PaymentQuestions.vue?vue&type=template&id=7bb4af9b"
import script from "./PaymentQuestions.vue?vue&type=script&lang=js"
export * from "./PaymentQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports